export const TEXT_MAX_LENGTH = 2000;
export const TEXT_MEDIUM_LENGTH = 1000;
